<template>
    <form>
        <div class="uk-margin">
          <div class="uk-inline">
            <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: calendar"></span>
            <flat-pickr :config="configArrival" v-model="arrival" :placeholder="textArrival" input-class="uk-input uk-form-width-medium" type="text"></flat-pickr>
          </div>
          <div class="uk-inline">
            <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: calendar"></span>
            <flat-pickr :config="configDeparture" v-model="departure" :placeholder="textDeparture" input-class="uk-input uk-form-width-medium" type="text"></flat-pickr>
          </div>
          <div class="uk-inline">
            <button @click.prevent="send" class="uk-button uk-button-primary">{{textButton}}</button>
          </div>
        </div>
    </form>
</template>

<script>

  import moment from 'moment'
  import _ from 'lodash'
  import SyleHelpers from '../styles.js'
  import flatPickr from 'vue-flatpickr-component'
  const German = require('flatpickr/dist/l10n/de.js').de
  const English = require('flatpickr/dist/l10n/de.js').en
  moment.locale('de')
  export default {
    components: {
      flatPickr
    },
    props: {
      url: {
        type: String
      },
      font: {
        type: String,
        default: 'inherit'
      },
      fontSize: {
        type: String,
        default: 'inherit'
      },
      fontWeight: {
        type: String,
        default: 'normal'
      },
      locale: {
        type: String,
        default: 'de'
      },
      textDeparture: {
        type: String,
        default: 'Abreise'
      },
      textArrival: {
        type: String,
        default: 'Anreise'
      },
      textButton: {
        type: String,
        default: 'Weiter'
      }
    },
    computed: {
      configDeparture() {
        return {
          locale: (this.locale === 'de') ? German : English,
          altFormat: 'd.m.Y',
          altInput: true,
          minDate: (this.arrival) ? moment(this.arrival).add(1, 'day').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
        }
      }
    },
    methods: {
      send () {
        const arrival = moment(this.arrival).format('DD.MM.YYYY')
        const departure = moment(this.departure).format('DD.MM.YYYY')
        const url = this.url + '?anreise=' + arrival + '&abreise=' + departure
        console.log(url)
        document.location.href = url
      }
    },
    data () {
      return {
        arrival: '',
        departure: '',
        configArrival: {
          locale: (this.locale === 'de') ? German : English,
          altFormat: 'd.m.Y',
          altInput: true,
          minDate: 'today'
        }
      }
    }
  }
</script>
<style>
    ::-webkit-input-placeholder { /* WebKit browsers */
        color: #666;
    }
    :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
       color: #666;
    }
    ::-moz-placeholder { /* Mozilla Firefox 19+ */
       color: #666;
    }
    :-ms-input-placeholder { /* Internet Explorer 10+ */
       color: #666;
    }

    textarea::-webkit-input-placeholder { /* WebKit browsers */
        color: #666;
    }
    textarea:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
       color: #666;
    }
    textarea::-moz-placeholder { /* Mozilla Firefox 19+ */
       color: #666;
    }
    textarea:-ms-input-placeholder { /* Internet Explorer 10+ */
       color: #666;
    }
</style>


// WEBPACK FOOTER //
// App.vue?386b6454